import React, { Component } from "react";
import { Container } from "reactstrap";
import { NavMenu } from "./NavMenu";

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu
          currentUser={this.props.currentUser}
          logoff={this.props.logoff}
          appVersion={this.props.appVersion}
          impersonating={this.props.impersonating}
          clearImpersonation={this.props.clearImpersonation}
        />
        <Container fluid className="p-2">
          {this.props.children}
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js